import { useQuery } from '@tanstack/react-query';
import { ListDailiesRequest } from 'src/api/FiretrolApiClient';
import { dailyApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Daily reports matching a job/user/date-range filter. */
export function useDailys(
  request: ListDailiesRequest,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKeys.dailys.list(request),
    queryFn: ({ signal }) =>
      dailyApiClient.list(request, toCancelToken(signal)),
    enabled: options?.enabled !== false,
    meta: { errorContext: 'daily list' },
  });
}
